import {
  isEmpty,
  invalidEmail,
  invalidPassword,
  checkPasswordContainsSpace,
  checkConfirmPassword,
  checkVerficationCode,
} from "./rules";

export const validateSignUp = signUp => {
  const invalid = {
    firstName: isEmpty(signUp.firstName, "First Name"),
    lastName: isEmpty(signUp.lastName, "Last Name"),
    email: invalidEmail(signUp.email),
    password: invalidPassword(signUp.password),
  };

  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;
  if (valid) {
    invalid.signUpValid = true;
  }
  return invalid;
};

export const validateLogin = login => {
  const invalid = {
    loginEmail: invalidEmail(login.email),
    loginPassword: checkPasswordContainsSpace(login.password),
  };
  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;
  if (valid) {
    invalid.loginValid = true;
  }
  return invalid;
};

export const validateVerificationCode = signUp => {
  const invalid = {
    verificationCode:
      isEmpty(signUp.verificationCode, "Verification Code") ||
      checkVerficationCode(signUp.verificationCode),
  };
  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;
  if (valid) {
    invalid.verificationValid = true;
  }
  return invalid;
};

export const validateForgotPassword = forgotPassword => {
  const invalid = {
    forgotPasswordEmail: invalidEmail(forgotPassword.forgotPasswordEmail),
  };
  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;
  if (valid) {
    invalid.forgotPasswordValid = true;
  }
  return invalid;
};

export const validateResetPassword = resetPassword => {
  const invalid = {
    resetPassword: invalidPassword(resetPassword.resetPassword),
    resetConfirmPassword: checkConfirmPassword(resetPassword),
  };
  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;
  if (valid) {
    invalid.resetPasswordValid = true;
  }
  return invalid;
};
